import axios from 'axios'
const API_URL = 'https://api.herdadesaomiguel.com'

const api = {
    async getWines (args) {
        const params = {
            brand_id: args.brand_id
        }
        const records = await axios.get(API_URL + '/wines.php', { params })
        return records.data
    },

    async getBrands () {
        const records = await axios.get(API_URL + '/brands.php')
        return records.data
    },

    async getAll () {
        const records = await axios.get(API_URL + '/all.php')
        return records.data
    },

    async getNews () {
        const records = await axios.get(API_URL + '/news.php')
        return records.data
    }
}

export default api
